import Component from './Component'
import Upsell from './Trigger'
import Paywall from './Paywall/index'
import Banner from './Banner'

export { Upsell, Paywall, Banner }
export default Component
